import {
    Route,
    Routes,
    Link,
    Navigate,
} from "react-router-dom";

import CookieConsent from "react-cookie-consent";
import NavBar, {NAVBARHEIGHT} from "./Components/NavBar/NavBar";
import {Box, Grid, Stack, styled, Typography} from "@mui/material";
import {FlexBox} from "./Util/styledComponents";

import SectionPage from "./Pages/SectionPage";
import SubjectPage from "./Pages/SubjectPage";
import HomePage from "./Pages/Home";
import ArticlePage from "./Pages/ArticlePage";
import {authListener} from "./Util/firebase";
import {useEffect, useState} from "react";
import Login from "./Pages/Login";
import Dashboard from "./Pages/Dashboard";


const SiteMapWrapper = styled(Box)`
border-top: 1px solid lightgrey;
padding: 50px;
margin-top: 64px;
display: flex;
justify-content: center;

a {
    color: #919191
}

p {
    font-weight: 600;
}
`;

export default function App() {
    const [user, setUser] = useState<boolean|null>(null);

    useEffect(() => {
        return authListener(setUser);
    }, []);

    const bottomLinks = () => {
        return (
            <SiteMapWrapper>
                <Grid container sx={{maxWidth: "700px"}}>
                    <Grid item xs={12} sm={4}>
                        <Stack alignItems={"center"}>
                            <Typography>Learn</Typography>
                            <Link to={"/learn/biology"}>Biology</Link>
                            <Link to={"/learn/chemistry"}>Chemistry</Link>
                            <Link to={"/learn/physics"}>Physics</Link>
                            <Link to={"/learn/maths"}>Maths</Link>
                        </Stack>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Stack alignItems={"center"}>
                            <Typography>News</Typography>
                            <Link to={"/news/biology"}>Biology</Link>
                            <Link to={"/news/chemistry"}>Chemistry</Link>
                            <Link to={"/news/physics"}>Physics</Link>
                            <Link to={"/news/maths"}>Maths</Link>
                        </Stack>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Stack alignItems={"center"}>
                            <Typography>Company</Typography>
                            <Link to={"/terms"}>Terms and Conditions</Link>
                            <Link to={"/privacy"}>Privacy Policy</Link>
                            <Link to={"/login"}>Login</Link>
                        </Stack>
                    </Grid>
                </Grid>
            </SiteMapWrapper>);
    };

    if (user === null) {
        return null;
    }

    const routes = (
        <FlexBox flexDirection={"column"} flex={1}>
            <NavBar/>
            <Box id="flex" sx={{scrollBehavior: "smooth"}} overflow={"auto"} mt={NAVBARHEIGHT}>
                <Routes>
                    <Route path="/" element={<HomePage/>}/>
                    <Route path="/news" element={<SectionPage/>}/>
                    <Route path="/learn" element={<SectionPage/>}/>
                    <Route path="/news/*" element={<SubjectPage/>}/>
                    <Route path="/learn/*" element={<SubjectPage/>}/>
                    <Route path="/article/:id" element={<ArticlePage/>}/>
                    <Route path="login" element={user ? <Navigate to={"/dashboard"} /> : <Login />} />
                    <Route path="dashboard" element={user ? <Dashboard/> : <Navigate to={"/login"} />} />
                </Routes>
                {bottomLinks()}
            </Box>
            <CookieConsent style={{textAlign: "left", background: "white", color: "black", boxShadow: "rgba(0, 0, 0, 0.3) 0px 0px 5px 0px"}} buttonStyle={{background: "#ffe71d", width: "max-content", padding: "10px", borderRadius: "20px", color: "white"}}>
                This website uses cookies to enhance the user experience.
            </CookieConsent>
        </FlexBox>
    );
    return routes;
}
